import { __extends } from "tslib";
import { FormError, FormFieldValidator } from "Login/Decorator/Validator";
var PasswordRepeatValidator = /** @class */ (function (_super) {
    __extends(PasswordRepeatValidator, _super);
    function PasswordRepeatValidator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PasswordRepeatValidator.prototype.isValid = function (input) {
        var formError = new FormError();
        if (input.password && input.passwordRepeat)
            formError
                .assert(input.password === input.passwordRepeat, 'validation.passwordRepeat.notMatching');
        return formError;
    };
    return PasswordRepeatValidator;
}(FormFieldValidator));
export { PasswordRepeatValidator };
